import React from 'react';
import TextField from '@mui/material/TextField';

const CustomTextField = ({
  label,
  type,
  value,
  onBlur,
  onChange,
  variant,
  inputRef,
  onKeyDown,
  InputProps,
  ...otherProps
}) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onKeyDown?.(event);
      return;
    }

    // Overwrite the character under the caret, like a DOS editor.
    if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey && inputRef?.current) {
      const input = inputRef.current;
      const start = input.selectionStart ?? value.length;
      const end = input.selectionEnd ?? start;
      const nextValue = value.slice(0, start) + event.key + value.slice(end);
      const nextCaret = Math.min(start + 1, nextValue.length);
      event.preventDefault();
      onChange({ target: { value: nextValue } });
      requestAnimationFrame(() => input.setSelectionRange(nextCaret, nextCaret));
    }
  };

  return (
    <TextField
    
      label={label}
      type={type}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      variant={variant}
      inputRef={inputRef}
      onKeyDown={handleKeyDown}
      InputProps={{
        ...InputProps,
        style: {  ...InputProps?.style }
      }}
      {...otherProps}
    />
  );
};

export default CustomTextField;
